import React from "react";
import PremiumTimePicker from "./index";

/**
 * Drop-in replacement for the legacy `TimeDropdown` (string "HH:mm" value +
 * onChange). Renders the shared premium picker with no floating label (these
 * forms render their own label above the field) and keeps the field required
 * (non-clearable), matching the old dropdown's behaviour. Overnight-aware via
 * the optional `nextDay` flag — the emitted value stays a time-of-day "HH:mm",
 * so each form's existing `spansNextDay` logic is untouched.
 */
const TimeField: React.FC<{ value?: string; onChange?: (time: string) => void; nextDay?: boolean; disabled?: boolean }> = ({
  value = "",
  onChange,
  nextDay,
  disabled,
}) => (
  <PremiumTimePicker
    label=""
    value={value}
    clearable={false}
    nextDay={nextDay}
    disabled={disabled}
    onChange={(v) => onChange?.(v)}
  />
);

export default TimeField;
